import { z } from 'zod';

const favCounter = z.object({
    value: z.number(),
});
const favStatistics = z.object({
    counter: favCounter,
});
const favoriteAd = z.object({
    urn: z.string(),
    insertDate: z.date(),
});
const favoriteAdsResponse = z.object({
    favorites: z.array(favoriteAd).optional(),
});

export { favCounter, favStatistics, favoriteAd, favoriteAdsResponse };
//# sourceMappingURL=zod.js.map
